import { CDN_ASSETS } from 'src/constants/common';

export const IMAGES = {
  LOUNGE_CHAIR: `${CDN_ASSETS}/banners/how-to-buy-tour/loungeChaireBall.png`,
  BALL: `${CDN_ASSETS}/banners/how-to-buy-tour/ball.png`,
  LOUNGE_CHAIR_SMILE: `${CDN_ASSETS}/banners/how-to-buy-tour/loungeChaireSmile.png`,
};
